import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Cormorant_Garamond, IBM_Plex_Mono, Shippori_Mincho } from 'next/font/google'

// Japanese body face. It also fills in any Japanese glyphs inside the display and mono stacks below.
const mincho = Shippori_Mincho({
    subsets: ['latin'],
    weight: ['400', '500', '600'],
    display: 'swap'
})

// Latin display face for the large English titles (variable weight, with italics).
const display = Cormorant_Garamond({
    subsets: ['latin'],
    style: ['normal', 'italic'],
    display: 'swap'
})

// Observation HUD labels, coordinates and small uppercase captions.
const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${mincho.style.fontFamily};--font-app-mono:${mono.style.fontFamily},${mincho.style.fontFamily};--font-app-heading:${display.style.fontFamily},${mincho.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
